import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Thread from "./Thread";
import UnrollTweetForm from "./UnrollTweetForm";

import { getThreadById } from "./apiService";

function ThreadView() {
  const { threadId } = useParams();
  const [thread, setThread] = useState({
    tweets: [],
    author: {},
    pulledFromLastTweet: false,
  });
  const [showLastTweetOverrideForm, setShowLastTweetOverrideForm] =
    useState(false);

  async function threadViewGetThread(id) {
    const res = await getThreadById(id);
    setThread(res);
  }

  useEffect(() => {
    setShowLastTweetOverrideForm(false);
  }, [thread]);

  useEffect(() => {
    threadViewGetThread(threadId);
  }, [threadId]);

  const toggleLastTweetOverrideForm = () => {
    setShowLastTweetOverrideForm(!showLastTweetOverrideForm);
  };

  const unrollThreadCallback = (response) => {
    threadViewGetThread(response.threadId);
  };

  return (
    <div className="min-h-screen p-6 bg-gray-100">
      <div className="flex flex-col items-center justify-center">
        {thread.pulledFromLastTweet && (
          <div className="flex flex-col w-11/12 sm:w-3/4 max-w-screen-md mb-4 text-left">
            <p className="">
              We couldn't reliably pull that thread due to Twitter API
              limitations, so we pulled as much as possible. If you want to
              reliably pull this whole thread, please
              <button
                className="mx-1 text-blue-500"
                onClick={toggleLastTweetOverrideForm}
              >
                click here
              </button>
              and enter the link to its last tweet.
            </p>

            {showLastTweetOverrideForm && (
              <div className="mt-4">
                <UnrollTweetForm
                  placeholder="Enter the URL of the last tweet in this thread"
                  invalidateCache={true}
                  existingThreadId={threadId}
                  callback={unrollThreadCallback}
                />
              </div>
            )}
          </div>
        )}
        <div className="w-11/12 sm:w-3/4 max-w-screen-md ">
          <Thread thread={thread} />
        </div>
      </div>
    </div>
  );
}

export default ThreadView;
